export const HttpStatus = {
  BAD_GATEWAY: 400,
  UNAUTHORIZED: 401,
  NOT_FOUND: 404,
  UNPROCESSABLE_ENTITY: 422,
  INTERNAL_SERVER_ERROR: 500,
};

export const SIGN_UP_ENDPOINT = '/api/v1/auth.json';
export const SIGN_IN_ENDPOINT = '/api/v1/auth/sign_in.json';
export const VALIDATE_TOKEN_ENDPOINT = '/api/v1/auth/validate_token';
export const REQUEST_FORGET_PASSWORD_ENDPOINT = '/api/v1/auth/password.json';
export const REQUEST_RESET_PASSWORD_ENDPOINT = '/api/v1/auth/password.json';
export const CONVERSATION_TREES_ENDPOINT = '/api/v1/conversation_trees';
export const CONVERSATION_TREES_ENDPOINT_BY_ID = id => `/api/v1/conversation_trees/${id}`;
export const GET_ALL_CONVERSATIONS_ENDPOINT = '/api/v1/conversations';
export const ACTIVITIES_LIKE_TOGGLE_ENDPOINT = id => `/api/v1/activities/${id}/likes_toggle`;
export const COMMENT_LIKE_TOGGLE_ENDPOINT = id => `/api/v1/comments/${id}/comment_likes_toggle`;
export const GET_COMMENTS_ENDPOINT = id => `/api/v1/conversations/${id}/comments`;
export const POST_COMMENTS_ENDPOINT = id => `/api/v1/conversations/${id}/comments`;
export const POST_VISUAL_STATUS_ENDPOINT = '/api/v1/visual_statuses.json';
export const GET_ACTIVITY_LIKES = activityId => `/api/v1/activities/${activityId}/likes`;
export const GET_COMMENT_LIKES = commentId => `/api/v1/comments/${commentId}/comment_likes`;
export const POST_DRAFT_ENDPOINT = '/api/v1/sketchpad_storages';
export const PUT_DRAFT_ENDPOINT = id => `/api/v1/sketchpad_storages/${id}`;
export const GET_DRAFT_INDEX_ENDPOINT = '/api/v1/sketchpad_storages';
export const GET_DRAFT_ENDPOINT = id => `/api/v1/sketchpad_storage_images/${id}`;
export const DELETE_DRAFT_ENDPOINT = id => `/api/v1/sketchpad_storages/${id}`;
export const GET_SEARCH_RESULTS = '/api/v1/search';
export const PUT_VISUAL_STATUS_ENDPOINT = id => `/api/v1/visual_statuses/${id}`;
export const GET_USER_BY_ID = userId => `/api/v1/users/${userId}`;
export const GET_USER_ACTIVITIES_BY_ID = userId => `/api/v1/users/${userId}/activities`;
export const ACTIVITIES_CURATIONS_ENDPOINT = id => `/api/v1/activities/${id}/curations_toggle`;
export const PUT_USER_PROFILE_ENDPOINT = id => `/api/v1/users/${id}`;
export const POST_FOLLOW_USER_ENDPOINT = '/api/v1/followers_toggle';

export const UNEXPECTED_ERROR = 'Something unexpected happened. Please contact administrator.';
export const UNAUTHORIZED_ERROR = 'Invalid Credentials';
export const EMAIL_NOT_FOUND = 'Email Not Found';
export const INVALID_REQUEST = 'INVALID REQUEST';
export const RESET_PASSWORD_EXPIRED = 'Please try forget password again';

export const TREE_EXTERNAL_COLLAPSE = 'collapsed';
export const TREE_EXTERNAL_ACTIVE = 'isActive';
export const TREE_NODE_ACTIVE_OPACITY = 1;
export const TREE_NODE_INACTIVE_OPACITY = 0.5;

export const DEFAULT_USER_THUMBNAIL = 'https://s3.amazonaws.com/dada-assets/default_user_pic.jpg';

export const AUTO_SAVE_TIME_DURATION = 5 * 60 * 1000; // 5 minutes

export const MAX_PHOTO_UPLOAD_SIZE = 4194304; // 4MB

export const ACCEPTABLE_PHOTO_FORMATS = 'image/png, image/jpeg';



// WEBPACK FOOTER //
// ./src/constants.js